import * as api from '@owl-nest/api-client/latest'
import { t } from '@owl-nest/localize'
import * as env from '@owl-nest/config'

export type NavSection = {
  items: {
    label: string
    href: string
    openInNewTab?: boolean
    language?: api.Lang
  }[]
  title: string
  href?: string
}

export type NavSections = NavSection[]

export function getNavSectionList(lang: api.Lang): NavSections {
  if (lang === 'fr') {
    return [
      {
        title: 'Ulule Crowdfunding',
        href: 'https://fr.ulule.com',
        items: [
          {
            label: t('Start a fundraising'),
            href: `${env.ULULE_ORIGINS[lang]}/projects/create/`,
          },
          {
            label: 'Voir toutes les collectes',
            href: `${env.ULULE_ORIGINS[lang]}/discover/`,
          },
          {
            label: 'Webinaire crowdfunding gratuit',
            href: 'https://connect.ulule.com/c/lives/?topics=223762',
            openInNewTab: true,
          },
          {
            label: 'Foire aux questions',
            href: 'https://support.ulule.com/hc/fr-fr',
            openInNewTab: true,
          },
          {
            label: 'Logo / Kits de campagne',
            href: `${env.ULULE_ORIGINS[lang]}/about/logos/`,
          },
          {
            label: 'Statistiques',
            href: `${env.ULULE_ORIGINS[lang]}/stats/`,
          },
        ],
      },
      {
        title: 'Communauté des makers',
        href: 'https://connect.ulule.com/',
        items: [
          {
            label: 'Prochains lives',
            href: 'https://connect.ulule.com/c/lives/',
            openInNewTab: true,
          },
          {
            label: 'Bons plans',
            href: 'https://connect.ulule.com/c/bonsplans/',
            openInNewTab: true,
          },
          {
            label: 'Demander un conseil',
            href: 'https://connect.ulule.com/c/entraide/',
            openInNewTab: true,
          },
          {
            label: 'Tutoriels',
            href: 'https://connect.ulule.com/c/tutoriels/',
            openInNewTab: true,
          },
          {
            label: 'Petites annonces',
            href: 'https://connect.ulule.com/c/petites-annonces/',
            openInNewTab: true,
          },
          {
            label: 'Replays',
            href: 'https://connect.ulule.com/c/replays-124572/',
            openInNewTab: true,
          },
        ],
      },
      {
        title: 'Partenaires',
        items: [
          {
            label: 'Appels à projets',
            href: `${env.ULULE_ORIGINS[lang]}/pages/appel-a-projet/`,
          },
          {
            label: 'Devenir partenaire',
            href: 'https://partenaires.ulule.com/',
          },
          {
            label: 'Organiser un appel à projets',
            href: 'https://partenaires.ulule.com/organiser-appel-projets',
          },
          {
            label: 'Nos dispositifs',
            href: 'https://partenaires.ulule.com/#dispositifs',
          },
          {
            label: 'API',
            href: 'https://developers.ulule.com/',
          },
        ],
      },
      {
        title: 'À propos d’Ulule',
        items: [
          {
            label: 'Découvrir Ulule',
            href: `${env.ULULE_ORIGINS[lang]}/pages/discover/`,
          },
          {
            label: 'Nous contacter',
            href: `${env.ULULE_ORIGINS[lang]}/about/contact/`,
          },
          {
            label: 'Équipe',
            href: `${env.ULULE_ORIGINS[lang]}/about/team/`,
          },
          {
            label: 'Presse',
            href: `${env.ULULE_ORIGINS[lang]}/about/press/`,
          },
          {
            label: 'Newsletter',
            href: `${env.ULULE_ORIGINS[lang]}/newsletter/`,
          },
        ],
      },
    ]
  } else {
    return [
      {
        title: t('Help and resources'),
        items: [
          {
            label: t('Start a fundraising'),
            href: `${env.ULULE_ORIGINS[lang]}/projects/create?utm_source=ulule&utm_medium=footer&utm_campaign=bas_de_homepage`,
          },
          {
            label: t('FAQ'),
            href: `https://support.ulule.com/hc/`,
          },
          {
            label: t('Contact us'),
            href: `${env.ULULE_ORIGINS[lang]}/about/contact-us?utm_source=ulule&utm_medium=footer&utm_campaign=bas_de_homepage`,
          },
          {
            label: t('Statistics'),
            href: `${env.ULULE_ORIGINS[lang]}/stats?utm_source=ulule&utm_medium=footer&utm_campaign=bas_de_homepage`,
          },
          {
            label: t('Open API'),
            href: 'https://developers.ulule.com?utm_source=ulule&utm_medium=footer&utm_campaign=bas_de_homepage',
          },
          {
            label: t('Branding guidelines'),
            href: `${env.ULULE_ORIGINS[lang]}/about/logos/`,
          },
        ],
      },
      {
        title: t('Focus on'),
        items: [
          /* HACK: Cannot solely rely on i18n.get() on ulule/next since it depends on "ufe.locale", which doesn't reflect the real-world value. */
          {
            label: t('How works Ulule?'),
            href: {
              en: 'https://support.ulule.com/hc/en-us/articles/211812489-What-is-Ulule-',
              es: 'https://community.ulule.com/topics/guia-de-creacion-de-tu-campana-de-crowdfunding-16917/#main-30775?utm_source=ulule&utm_medium=footer&utm_campaign=bas_de_homepage',
              fr: 'https://formations.ulule.com/bilan-de-competences?utm_source=ulule&utm_medium=footer&utm_campaign=bas_de_homepage',
              it: 'https://community.ulule.com/topics/tre-cerchi-del-finanziamento-collettivo-crowdfunding-8749?utm_source=ulule&utm_medium=footer&utm_campaign=bas_de_homepage',
              nl: 'https://support.ulule.com/hc/nl/articles/211812489-Ulule-wat-is-dat-',
            }[lang],
          },
          {
            label: t('Supported countries'),
            href: {
              en: 'https://support.ulule.com/hc/en-us/articles/212423305-From-which-country-can-I-start-a-crowdfunding-campaign-on-Ulule-',
              es: 'https://support.ulule.com/hc/es-es/articles/10510451394449--Cu%C3%A1l-es-la-diferencia-entre-los-tres-m%C3%A9todos-de-recaudaci%C3%B3n',
              fr: 'https://formations.ulule.com/crowdfunding?utm_source=ulule&utm_medium=footer&utm_campaign=bas_de_homepage',
              it: 'https://community.ulule.com/topics/le-campagne-di-crowdfunding-e-il-loro-obiettivo-finanziario-come-calcolarlo-e-quando-perche-applicare-la-strategia-dello-step-by-step-13945?utm_source=ulule&utm_medium=footer&utm_campaign=bas_de_homepage',
              nl: 'https://support.ulule.com/hc/nl/articles/212423305-Vanuit-welk-land-mag-ik-een-campagne-lanceren-op-Ulule-',
            }[lang],
          },
          {
            label: t('Eligible projects'),
            href: {
              en: 'https://support.ulule.com/hc/en-us/articles/212423325-What-kinds-of-projects-are-eligible-',
              es: 'https://support.ulule.com/hc/es-es/articles/212423325',
              fr: 'https://formations.ulule.com/formation-webmarketing?utm_source=ulule&utm_medium=footer&utm_campaign=bas_de_homepage',
              it: 'https://community.ulule.com/topics/il-retroplanning-per-aumentare-le-chance-di-successo-della-propria-campagna-di-crowdfunding-9962?utm_source=ulule&utm_medium=footer&utm_campaign=bas_de_homepage',
              nl: 'https://support.ulule.com/hc/nl/articles/212423325-Welke-projecten-komen-in-aanmerking-',
            }[lang],
          },
        ],
      },
      {
        title: t('About ulule'),
        items: [
          {
            label: t('Discover Ulule'),
            href: `${env.ULULE_ORIGINS[lang]}/pages/discover/?utm_source=ulule&utm_medium=footer&utm_campaign=bas_de_homepage`,
          },
          {
            label: 'Ulule partners',
            href: `https://partenaires.ulule.com/espana`,
            language: 'es',
          },
          {
            label: t('Team'),
            href: `${env.ULULE_ORIGINS[lang]}/about/team?utm_source=ulule&utm_medium=footer&utm_campaign=bas_de_homepage`,
          },
        ],
      },
    ]
  }
}
